<!-- eslint-disable -->
<template>
    <div class="patient-record-container">
        <div v-if="isLoading" class="preloader-container">
            <Preloader />
        </div>
        <div v-else-if="error" class="error-container">
            <ErrorAlert :error-message="error" />
        </div>
        <div v-else-if="patientRecord" class="content-container">
            <PatientWorkspace :patient-id="patientRecord.id" />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue';
import { useStore as useExpedientesStore } from '@/store/Expedientes/pacientes.js';
import { patientEventBus } from '@/utils/eventBus.js';
// ✅ Imports absolutos corregidos
import Preloader from '@/components/Preloader.vue';
import ErrorAlert from '@/components/ErrorAlert.vue';
import PatientWorkspace from '@/components/MedicalRecord/PatientWorkspace.vue';

const props = defineProps({
    patientId: {
        type: [String, Number],
        required: true,
    },
});

const { getPatientDataById } = useExpedientesStore();
const patientRecord = ref(null);
const isLoading = ref(true);
const error = ref(null);
let unsubscribe = null;

// Función para cargar los datos del paciente
const loadPatientData = () => {
    try {
        isLoading.value = true;
        error.value = null;

        const data = getPatientDataById(props.patientId);
        if (data) {
            patientRecord.value = data;
        } else {
            throw new Error(`No se encontró el paciente con ID: ${props.patientId}`);
        }
    } catch (e) {
        console.error("Error fetching patient data:", e);
        error.value = "No se pudo cargar la información del paciente. Por favor, intente de nuevo más tarde.";
        patientRecord.value = null;
    } finally {
        isLoading.value = false;
    }
};

// Función para manejar actualizaciones desde el Event Bus
const handlePatientUpdate = (updatedData) => {
    if (patientRecord.value && updatedData.id === patientRecord.value.id) {
        Object.assign(patientRecord.value, updatedData);
    }
};

// Watcher para cambios en patientId
watch(() => props.patientId, (newPatientId) => {
    if (newPatientId) {
        // Desuscribirse del paciente anterior si existe
        if (unsubscribe) {
            unsubscribe();
        }

        loadPatientData();
        unsubscribe = patientEventBus.subscribe(newPatientId, handlePatientUpdate);
    }
}, { immediate: false });

onMounted(() => {
    loadPatientData();
    // Suscribirse a actualizaciones del Event Bus
    unsubscribe = patientEventBus.subscribe(props.patientId, handlePatientUpdate);
});

onUnmounted(() => {
    if (unsubscribe) {
        unsubscribe();
    }
});
</script>

<style scoped>
.patient-record-container {
    width: 100%;
}

.preloader-container,
.error-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50vh;
}

.content-container {
    margin: 0;
    padding: 0;
}
</style>
